module.exports = __webpack_public_path__ + "static/media/yashwardhan.a276dbbd.jpg";